export default __webpack_public_path__ + "static/media/conduiitWTIcon.a0a770d7.svg";